export enum SERVICE_ACTION_TYPES {
  FETCH_SERVICES = "service/FETCH_SERVICES",
  FETCH_SERVICE_PROVIDERS = "service/FETCH_SERVICE_PROVIDERS",
  SET_SERVICES = "service/SET_SERVICES",
  FETCH_DISPLAY_SERVICES = "service/FETCH_DISPLAY_SERVICES",
}
export interface Service {
  _id: string;
  service: string;
  image: string;
  description: string;
  carouselImages: string[];
}
export interface ServiceDropDown {
  _id: string;
  service: string;
}
export interface House {
  _id: string;
  agentId: string;
  title: string;
  image: string;
  description: string;
  address: number;
  amount: string;
  phoneNumber: string;
  businessName: string;
  typeId: string;
}
export interface Business {
  _id: string;
  businessName: string;
  profileImage: string;
  pageRoute: string;
  description: string;
  ratingAverage: number;
  availability: string;
}
export type ServiceProviders = Business[];
export type ServiceGroup = Service[][];
